import React from 'react'

import HeadCountModel from './HeadCountModel'
import HeadCount from './HeadCount'

const id = 'tpi.dataViewers.HeadCountSupportDataViewer'

export default {
  id,
  type : 'tpi.HeadCountSuppot',
  name : 'Head Count Support',
  icon : 'fa fa-history fa-fw',
  location : 'none',
  matches : {
    type : 'ItemInfoDataViewer',
    objectType : 'moldHalf',
  },
  createSettings : ( props ) => {
    return HeadCountModel.create()
  },
  render : ( props ) => {
    return React.createElement( HeadCount, props )
  },
  getDefaultCardOptions : { height : 'auto' }
}
